import React from 'react';
import { appContext } from '../../util/decorators';
import ArticleLink from '../ArticleLink.jsx';

@appContext
export default class FeedContainerList extends React.PureComponent {
  render() {
    return (
      <div className="feed-container feed-container-list">
        <h2>{this.context.app.t(this.props.config.title)}</h2>
        <ul>
          {
            this.props.articles &&
              this.props.articles.map((item, index) => {
                if (index >= this.props.limit) return false;

                return (
                  <li key={item.slug}>
                    <ArticleLink contentContainer={item}>{item.newsFeedTitle || item.title}</ArticleLink>
                  </li>
                );
              })
          }
        </ul>
      </div>
    );
  }
}

FeedContainerList.propTypes = {
  limit: React.PropTypes.number,
  articles: React.PropTypes.array.isRequired,
  config: React.PropTypes.shape({
    title: React.PropTypes.string.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedContainerList.jsx